import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface FullscreenMenuProps {
  isOpen: boolean;
  onClose: () => void;
}
const menuItems = [{
  label: 'Inicio',
  target: 'inicio'
}, {
  label: 'La Estancia',
  target: 'la-estancia'
}, {
  label: 'La Experiencia',
  target: 'la-experiencia'
}, {
  label: 'La Mesa',
  target: 'la-mesa'
}, {
  label: 'Bienestar',
  target: 'la-mesa'
}, {
  label: 'Explora Trujillo',
  target: 'explora-trujillo'
}, {
  label: 'Eventos',
  target: 'eventos'
}, {
  label: 'Nuestra Iniciativa',
  target: 'nuestra-iniciativa'
}, {
  label: 'Contacto',
  target: 'contacto'
}];
export function FullscreenMenu({
  isOpen,
  onClose
}: FullscreenMenuProps) {
  const handleItemClick = (target: string) => {
    onClose();
    setTimeout(() => {
      const element = document.getElementById(target);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      } else if (target === 'inicio') {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 300);
  };
  return <AnimatePresence data-id="element-40">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-[100] bg-[#FAF8F5]" data-id="element-41">
          {/* Close button */}
          <button onClick={onClose} aria-label="Close menu" className="fixed top-5 left-6 md:left-16 lg:left-24 z-[101] text-[#2C2420] hover:opacity-60 transition-opacity focus:outline-none" data-id="element-42">
            <XIcon size={24} strokeWidth={1.5} data-id="element-43" />
          </button>

          {/* Menu items */}
          <div className="flex h-full w-full items-center justify-center" data-id="element-44">
            <nav className="flex md:gap-8 gap-[14px] flex-col items-start justify-start" data-id="element-45">
              {menuItems.map((item, index) => <motion.button key={item.target} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1 + index * 0.05,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} onClick={() => handleItemClick(item.target)} className="font-serif md:text-3xl uppercase tracking-[0.15em] text-[#2C2420] hover:opacity-60 transition-opacity focus:outline-none text-[14px]" data-id="element-46">
                  {item.label}
                </motion.button>)}
            </nav>
          </div>
        </motion.div>}
    </AnimatePresence>;
}